import React from "react";

export const Standard = {
    title: "Standard",
    subTitleOne:
    <div>
        For individuals and businesses seeking a simple,
        one-stop solution for peace of mind.
    </div>,
    description: " ",
    listHeader: "Package Includes",
    listElements: [
      "Tax Compliance +",
      "Bookkeeping",
    ]
};



// WEBPACK FOOTER //
// ./src/components/Packages/constants/Standard.constants.js